function translateRetirementSlider(marel, value) {
    let translated = marel.result[value || 0].age;

    if (translated.trim() === marel.age_full_rate.trim()) translated = `${translated} (taux plein)`;

    return translated;
}

export default translateRetirementSlider;
